const args = new Proxy(new URL(location.href).searchParams, {
  get(target, key) {
    return target.get(key);
  },
});

export default args;
